import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Lock, Eye, EyeOff, AlertCircle } from 'lucide-react';

const MAIN_LOGO = "https://customer-assets.emergentagent.com/job_goalgeous-hub/artifacts/ad5dhro0_Untitled%20design.png";

export const AdminLoginPage = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/admin/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ username, password })
      });

      if (!response.ok) {
        throw new Error('Invalid credentials');
      }

      const data = await response.json();
      localStorage.setItem('adminToken', data.access_token);
      navigate('/admin/dashboard');
    } catch (err) {
      setError('Invalid username or password');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-brand-black flex items-center justify-center px-4">
      <div className="max-w-md w-full">
        <div className="text-center mb-8">
          <img src={MAIN_LOGO} alt="Power Up Your Fitness" className="h-24 mx-auto mb-6" />
          <h1 className="font-oswald text-3xl uppercase text-white mb-2">Admin Portal</h1>
          <p className="font-montserrat text-brand-gray">Sign in to manage your site</p>
        </div>

        <form onSubmit={handleLogin} className="bg-brand-dark border border-white/10 p-8">
          {error && (
            <div className="flex items-center gap-2 bg-red-500/10 border border-red-500/30 p-3 mb-6">
              <AlertCircle size={18} className="text-red-500" />
              <span className="font-montserrat text-sm text-red-500">{error}</span>
            </div>
          )}

          <div className="mb-6">
            <label className="block font-oswald text-sm uppercase tracking-wider text-white mb-2">
              Username
            </label>
            <input
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              className="w-full bg-brand-black border border-white/20 px-4 py-3 text-white font-montserrat focus:border-brand-lime outline-none"
              required
              data-testid="admin-username"
            />
          </div>

          <div className="mb-8">
            <label className="block font-oswald text-sm uppercase tracking-wider text-white mb-2">
              Password
            </label>
            <div className="relative">
              <input
                type={showPassword ? 'text' : 'password'}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="w-full bg-brand-black border border-white/20 px-4 py-3 text-white font-montserrat focus:border-brand-lime outline-none pr-12"
                required
                data-testid="admin-password"
              />
              <button
                type="button"
                onClick={() => setShowPassword(!showPassword)}
                className="absolute right-4 top-1/2 -translate-y-1/2 text-brand-gray hover:text-white"
              >
                {showPassword ? <EyeOff size={20} /> : <Eye size={20} />}
              </button>
            </div>
          </div>

          <button
            type="submit"
            disabled={loading}
            data-testid="admin-login-btn"
            className="w-full bg-brand-lime text-brand-black font-oswald uppercase tracking-wider py-4 hover:bg-brand-pink hover:text-white transition-colors disabled:opacity-50"
          >
            {loading ? 'Signing in...' : 'Sign In'}
          </button>
        </form>

        <p className="text-center mt-6">
          <a href="/" className="font-montserrat text-sm text-brand-gray hover:text-brand-lime">
            ← Back to Website
          </a>
        </p>
      </div>
    </div>
  );
};
